import React from 'react'
import { useEffect, useState } from 'react'
import { createContext, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { logout } from '../reducers/actions/auth'
import { useDispatch } from 'react-redux'

export const VisitorFrontendContext = createContext({})

const VisitorFrontendProvider = ({ children }) => {

    const authToken = JSON.parse(sessionStorage.getItem('state'))
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [token, setToken] = useState(authToken?.auth?.token ? true : false)
    const location = useLocation();
    const path = location.pathname


    useEffect(() => {
        if (path != "/reset-password") {
            if (!token) {
                dispatch(logout());
                navigate("/Login");
            }
        }
    }, [token])


    return (
        <VisitorFrontendContext.Provider value={{ setToken }}>{children}</VisitorFrontendContext.Provider>
    )
}

export default VisitorFrontendProvider